import React from 'react'
import * as R from 'ramda'
import { utils } from '@ims/1edtech-frontend-common'

import { Screen, View, Spinner, SearchBox } from 'lib/components'
import BaseCommonCartridgeCharacterizationsBreadCrumbs from 'domains/characterizations/components/BaseCommonCartridgeCharacterizationsBreadCrumbs'
import useFullCommonCartridgeCharacterization from 'domains/commonCartridge/hooks/useFullCommonCartridgeCharacterization'
import GenericError from 'domains/application/components/GenericError'
import ICharacterization from 'domains/characterizations/models/ICharacterization'
import WidgetHeader from 'domains/dashboard/components/WidgetHeader'
import ICommonCartridgeCharacterizationReport from 'domains/commonCartridge/models/ICommonCartridgeCharacterizationReport'
import { getCharacterizationRoute } from 'domains/characterizations/navigation/routes'
import CommonCartridgeCharacterizationReportTOCList from 'domains/commonCartridge/components/CommonCartridgeCharacterizationReport/CommonCartridgeCharacterizationReportTOCList'
import trackCommonCartridgeAnalytics from 'domains/commonCartridge/utils/trackCommonCartridgeAnalytics'

export default function CommonCartridgeCharacterizationReportTOCScreen(
  props: any,
) {
  const [
    characterizationData,
    reportData,
    pending,
  ] = useFullCommonCartridgeCharacterization(props)
  const [query, setQuery] = React.useState('')

  if (
    pending ||
    !utils.hasValue(characterizationData) ||
    !utils.hasValue(reportData)
  ) {
    if (
      !pending &&
      (!utils.hasValue(characterizationData) || !utils.hasValue(reportData))
    ) {
      return <GenericError />
    }
    return (
      <Screen>
        <BaseCommonCartridgeCharacterizationsBreadCrumbs
          crumbs={[{ name: 'Table of contents' }]}
        />

        <View variant="paper">
          <WidgetHeader title="Table of Contents" />
          <Spinner centered={true} />
        </View>
      </Screen>
    )
  }

  const characterization = characterizationData as ICharacterization
  const characterizationName = R.pathOr('', ['name'], characterization)
  const report = reportData as ICommonCartridgeCharacterizationReport

  return (
    <Screen>
      <BaseCommonCartridgeCharacterizationsBreadCrumbs
        crumbs={[
          {
            name: utils.string.ellipsize(characterizationName, 30),
            route: getCharacterizationRoute(
              characterization.id,
              characterization.format,
            ),
          },
          { name: 'Table of contents' },
        ]}
      />

      <View variant="paper">
        <View flexible="row-space-between-wrap">
          <WidgetHeader title="Table of Contents" dataTest="screen-header" />

          <SearchBox
            name={`items-search`}
            trackEvent={trackCommonCartridgeAnalytics}
            trackEventAction={'cc-items-search'}
            onChange={setQuery}
            placeholder="Search..."
          />
        </View>

        <View mt={3} />
        <CommonCartridgeCharacterizationReportTOCList
          characterization={characterization}
          report={report}
          query={query}
          searchTemplate={'title=~@@ OR index=~@@'}
          params={utils.hasValue(query) ? { isCartridge: true } : {}}
          parentItemId={utils.hasValue(query) ? report.id : undefined}
        />
      </View>
    </Screen>
  )
}
